import { MfaSetup as MfaSetupFeature } from '../../../features/mfa-setup/components/mfa-setup';

const MfaSetup = () => <MfaSetupFeature />;

export { MfaSetup };
